import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import TableBusquedaComponent from './Trazabilidad/TableBusquedaComponent';

function PanelTrazabilidad(props) {
    return (
        <Fragment><br />
            <div className='container'>
                <h1>Trazabilidad</h1>
                <TableBusquedaComponent />
            </div>
        </Fragment>
    );
};


export default withRouter(PanelTrazabilidad)
